/**
 * @file _view/_related-post-adjust.js
 */
(function ($) {
	'use strict';

	/**
	 *
	 * @namespace RelatedPostAdjust
	 * @constructor
	 * @classdesc related postの高さを一番高いものに合わせる
	 * @param {jQuery} $e - 対象となる jQuery オブジェクト
	 */
	var RelatedPostAdjust = function ($e) {
		this._$e = $e;
		$(window).on('load resize', this.getMaxHeight.bind(this));
	};

	/**
	 * @memberOf RelatedPostAdjust
	 * @const
	 */
	RelatedPostAdjust._classname = 'RelatedPostAdjust';


	/**
	 * @memberOf RelatedPostAdjust
	 * @return {undefined}
	 */
	RelatedPostAdjust.prototype.getMaxHeight = function () {
		var hList = new Array();

		// 各related postの要素の高さを配列に格納する
		this._$e.children('li').each(function(idx) {
			hList[idx] = $(this).height();
		});

		var maxHeight = Math.max.apply(null, hList);
		this.setHeight(maxHeight);
	};

	/**
	 * @memberOf RelatedPostAdjust
	 * @param maxHeight
	 */
	RelatedPostAdjust.prototype.setHeight = function(maxHeight) {
		this._$e.children('li').css('height', maxHeight + 'px');
	};

	module.exports = RelatedPostAdjust;
})(jQuery);